import { logDebugging } from '../../log/logger';
import tappxCookieSync from '../cookiesync/tappxCookieSync';
import { getCmpFrame } from './getCmpFrame';
import globalConsent from './globalConsent';

/* eslint-disable camelcase */
const getUSConsentData = require('./getUSConsentData').default;
// const { getCmpFrame } = require('./getCmpFrame');
const getEUConsentData = require('./getEUConsentData').default;
// const { getParametersFromUrl } = require('../utils/urlUtils').default;
// const { logDebugging, setUpLogger } = require('../log/logger');

async function getConsent(endpoint) {
  let gdpr_consent = '';
  getCmpFrame();

  function attempConsentData() {
    let consentData = '';
    return new Promise((resolve) => {
      try {
        // eslint-disable-next-line no-underscore-dangle, no-undef
        window.top.__tcfapi('getTCData', 2, (tcReturn, success) => {
          logDebugging(tcReturn);
          if (success) {
            consentData = tcReturn.tcString;
            logDebugging(`CONSENT_DATA (SEGUNDO INTENTO): ${this.consentData}`);
            resolve(consentData);
          } else {
            resolve(consentData);
          }
        });
        setTimeout(() => {
          resolve(consentData);
        }, 700);
      } catch (error) {
        resolve(consentData);
      }
    });
  }

  getEUConsentData.init();
  gdpr_consent = await getEUConsentData.getConsentData();
  const us_privacy = await getUSConsentData.getConsentData();
  if (!gdpr_consent) {
    gdpr_consent = await attempConsentData();
  }
  logDebugging('gdpr_consent ', gdpr_consent);

  const params = {
    gdpr_consent,
    us_privacy,
  };

  globalConsent.gdpr_consent = gdpr_consent;
  globalConsent.us_privacy = us_privacy;

  const idCookieFrame = '2032b3863dafb3c';
  // eslint-disable-next-line no-undef
  if (!document.getElementById(idCookieFrame)) {
    tappxCookieSync.addCookieSync(endpoint, params);
  }

  return params;
}

export default {
  getConsent,
};
